import { TitleWithDescriptionCombinedProps } from './types';

const usePresenter = (props: TitleWithDescriptionCombinedProps): TitleWithDescriptionCombinedProps => {
  return props;
};

export default usePresenter;
